define(function() {
  'use strict';

  const inputs          = [...document.querySelectorAll('.input__field')],
      filledClassName = 'input--floating-label',
      autofillContent = `"${String.fromCharCode(0xFEFF)}"`;

  // workaround/hack to get autofill and set floating labels on chrome before first page click
  // value for empty -webkit-autofill set in css
  function checkAutofill(input, inputWrap) {
    if (!input.value) {
      const style = window.getComputedStyle(input);
      if (style.content !== autofillContent) {
        return false;
      }
    }
    inputWrap.classList.add(filledClassName);
    return true;
  }

  inputs.forEach(input => {
    const inputWrap = input.parentNode;
    input.addEventListener('input', () => {
      if (input.value) {
        inputWrap.classList.add(filledClassName);
      }
      else {
        inputWrap.classList.remove(filledClassName);
      }
    });

    input.addEventListener('focus', () => {
      inputWrap.classList.add(filledClassName);
    });

    input.addEventListener('blur', () => {
      if (!input.value) {
        inputWrap.classList.remove(filledClassName);
      }
    });

    // check the input to allow the autofill time to complete and if it is add floating class
    if (!checkAutofill(input, inputWrap)) {
      let interval = 0;
      const intervalId = setInterval(() => {
        if (checkAutofill(input, inputWrap) || interval++ >= 20) {
          clearInterval(intervalId);
        }
      }, 100);
    }
  });
});
